import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ClassicLoader } from "@components/ClassicLoader/ClassicLoader";
import { useAuthStore } from "@store/auth/auth";
import { AppKYCInitiator } from "./AppKYCInitiator";

export const AppKYCTokenWrapper: React.FC = () => {
  const { setToken, token } = useAuthStore();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      setToken(token);
      setInitialized(true);
    } else {
      navigate("/status/error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setToken, searchParams]);

  useEffect(() => {
    if (initialized && !token) {
      navigate("/status/error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, initialized]);

  if (!initialized) {
    return (
      <div className="flex h-dvh w-full items-center justify-center">
        <ClassicLoader />
      </div>
    );
  }

  return <AppKYCInitiator />;
};
